import { Card, CardContent } from "@/components/ui/card";
import ArEmployeePayslipForm from "@/v2/components/pages/payslip/ar-employee/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ReceiptTextIcon } from "lucide-react";
import { useParams } from "react-router-dom";

export default function EditArEmployeePayslipPage() {
  const { id } = useParams();
  return (
    <div className="my-3 min-h-screen">
      <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
        <FormPageHeading
          title="Payslip Management"
          description="Edit and manage employee payslips"
          Icon={ReceiptTextIcon}
        />
        <CardContent className="pt-6">
          <ArEmployeePayslipForm id={id} />
        </CardContent>
      </Card>
    </div>
  );
}
